import { Box, Text } from '@chakra-ui/react'
import { memo } from 'react'

import type { PostDetails, PostEventDetails } from '@/components/Community/Post/types'
import { withErrorBoundary } from '@/components/Worlds/UI/ErrorBoundary'

import PostEventComment from './PostEventComment'
import PostEventUserAction from './PostEventUserAction'

function PostEventNonMemoized({
  post,
  postEvent,
  onDelete,
  isOptimistic,
}: {
  post: PostDetails
  postEvent: PostEventDetails
  onDelete: (p: PostEventDetails) => void
  isOptimistic?: boolean
}): JSX.Element {
  if (postEvent.type === 'comment') {
    return (
      <PostEventComment
        post={post}
        postEvent={postEvent}
        onDelete={onDelete}
        isOptimistic={isOptimistic}
      />
    )
  }

  return <PostEventUserAction post={post} postEvent={postEvent} />
}

// Memoize this, so that changing one input doesn't affect the rendering
// of all the other inputs.
const PostEvent = memo(
  withErrorBoundary(PostEventNonMemoized, () => (
    <Box textAlign="center" _hover={{ bg: 'bg.subtle' }} px="24px" py="8px">
      <Text variant="supporting" color="fg.muted">
        Oops! There was an error displaying this content.
      </Text>
    </Box>
  )),
  (prevProps, newProps) =>
    prevProps.postEvent.id === newProps.postEvent.id &&
    prevProps.postEvent.updatedAt === newProps.postEvent.updatedAt
)

export default PostEvent
